import { html } from "../../../../"
import type { SYSDialog } from "../../../../index"
import { T } from "../../../../global/globals"
import { SYSBaseElement } from "../../../sysbaseelement"
import type { SYSFormState } from "../../actions"
import { FormIsLocked, FormIsValid } from "../../formapi"

export type SYSOkCancelDeleteFooterType = {
  formState: SYSFormState
  okFn: (e: Event) => void
  cancelFn: (e: Event) => void
  deleteFn: (e: Event) => void
  dialog: SYSDialog
  dialogInstance?: any
}

export class SYSOkCancelDeleteFooter extends SYSBaseElement {
  props: any
  controlState: SYSOkCancelDeleteFooterType
  async init() {
    this.controlState = this.props(this.state)
    if (!this.controlState.dialogInstance) {
      this.controlState.dialogInstance = this.controlState.dialog
    }
    this.formState = this.controlState.formState
    await super.init()
  }

  async getUI() {
    let accept
    let acceptClass = "fd-button ovl-disabled"
    let cancel
    let cancelClass = "fd-button ovl-disabled"
    let deleteBtnDisabled = false
    let dlg = this.controlState.dialog
    let dlgInstance = this.controlState.dialogInstance
    if (
      !this.formState.locked &&
      !(
        dlg &&
        (this.state.ovl.dialogs[dlg].instance[dlgInstance]?.disabled ||
          this.state.ovl.dialogs[dlg].instance[dlgInstance]?.closing)
      )
    ) {
      if (FormIsValid(this.formState)) {
        accept = html`<i class="sap-icon--accept"></i>`
        acceptClass = "fd-button fd-button--positive"
      }
      if (
        !this.formState._state
          ._noCancelOnEditFormIfFormStateWasInvalidWhenOpened
      ) {
        cancel = html`<i class="sap-icon--decline"></i>`
        cancelClass = "fd-button fd-button--negative"
      }
    }

    let deleteButton
    if (this.controlState.deleteFn) {
      deleteButton = html` <button
        ?disabled=${deleteBtnDisabled}
        @click=${(e) => {
          // we need to check FormIsLocked beacause if it gets touched on mobile it needs to do that (usecase b&k ggn tab out or click)

          if (!FormIsLocked(this.formState)) this.controlState.deleteFn(e)
        }}
        title="${T("SYSDelete")}"
        class="fd-button fd-button--negative"
      >
        <i class="sap-icon--delete"></i>
      </button>`
    }

    return html`
      <button
        id="SYSEditAccept${this._id}"
        @click=${(e) => {
          // we need to check FormIsLocked beacause if it gets touched on mobile it needs to do that (usecase b&k ggn tab out or click)

          if (!FormIsLocked(this.formState) && FormIsValid(this.formState))
            this.controlState.okFn(e)
        }}
        title="${T("SYSTableRowFnSave")}"
        class="${acceptClass}"
      >
        ${accept}
      </button>
      ${deleteButton}

      <button
        id="SYSEditCancel${this._id}"
        @click=${async (e) => {
          if (!e.target.classList.contains("ovl-disabled")) {
            if (!FormIsLocked(this.formState)) {
              await this.controlState.cancelFn(e)
            }
          }
        }}
        title="${T("SYSCancel")}"
        class=${cancelClass}
      >
        ${cancel}
      </button>
    `
  }
  async disconnectedCallback() {
    this.controlState.cancelFn = null
    this.controlState.deleteFn = null
    this.controlState.okFn = null
    await super.disconnectedCallback()
  }
}
